var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-wrap"},[_c('v-app',{staticClass:"hmc-app"},[_c('v-main',{staticClass:"main-body"},[_c('v-container',{staticClass:"app-body"},[(_vm.tutorialApi.isError)?_c('ApiErrorDialog',{attrs:{"api":_vm.tutorialApi}}):_vm._e(),(_vm.finished)?_c('FinishedBanner'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }